module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "block block-link-shadow block-rounded block-bordered",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "py-5 text-center"
  }, [_c('div', {
    staticClass: "mb-15"
  }, [_c('i', {
    class: [("fa fa-" + _vm.icon + " fa-3x text-muted")]
  })]), _vm._v(" "), _c('div', {
    staticClass: "font-size-sm font-w600 text-uppercase text-muted"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38b8bd20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/barcode-scanner/BarcodeScannerType.vue
// module id = 705
// module chunks = 1